export enum UsageOccasion {
    DayTime = 'Day time',
    NightTime = 'Night time'
}
